import React from 'react';
import { NavLink } from 'react-router-dom';
import { ENABLE_PNR_CONVERTER } from '../constants/agent';

const Navigation = () => {
  return (
    <nav className="navbar navbar-expand-lg bg-dark bg-opacity-25 border-top border-white border-opacity-25">
      <div className="container-fluid">
        <button 
          className="navbar-toggler border-white border-opacity-50" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#mainNavbar" 
          aria-controls="mainNavbar" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="mainNavbar">
          <ul className="navbar-nav w-100 justify-content-center gap-2">
            <li className="nav-item">
              <NavLink 
                to="/" 
                end 
                className={({ isActive }) => 
                  `nav-link text-white px-4 py-2 rounded ${isActive ? 'bg-white bg-opacity-25 fw-semibold' : 'text-white-50'}`
                }
              >
                Dummy Ticket Generator
              </NavLink>
            </li>
            {ENABLE_PNR_CONVERTER && (
              <li className="nav-item">
                <NavLink 
                  to="/pnr-converter" 
                  className={({ isActive }) => 
                    `nav-link text-white px-4 py-2 rounded ${isActive ? 'bg-white bg-opacity-25 fw-semibold' : 'text-white-50'}`
                  }
                >
                  PNR Converter
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;

